import { createContext, ReactNode, useContext, useState } from "react";

type ChatbotContextType = {
  chatbotStatus: string;
  handleChatBotStatusChange: (status: string) => void;
  isChatbotActive: boolean;
  isChatbotLoading: boolean;
};

const ChatbotContext = createContext<ChatbotContextType | undefined>(undefined);

export const ChatbotContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [chatbotStatus, setChatbotStatus] = useState("loading");

  const handleChatBotStatusChange = (status: string) =>
    setChatbotStatus(status);

  return (
    <ChatbotContext.Provider
      value={{
        chatbotStatus,
        handleChatBotStatusChange,
        isChatbotActive: chatbotStatus === "chatactive",
        isChatbotLoading: chatbotStatus === "loading",
      }}
    >
      {children}
    </ChatbotContext.Provider>
  );
};

export const useChatbotContext = () => {
  const context = useContext(ChatbotContext);
  if (!context) {
    throw new Error(
      "useChatbotContext must be used within a ChatbotContext.Provider",
    );
  }
  return context;
};
